import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Final = () => {
  const navigate = useNavigate();

  const firstpage = () => {
    navigate("/encryptionview", {
      state: {
        hexplaintext,
        hexkey,
        AllexcryptionResults,
        binary64bitValueSwapped,
        cipherhex,
        bytes,
        inputValue,
        KeyValue,
        splitted_array,
        allResults,
        // finalEncryptedValue,
      },
    });
  };

  const location = useLocation();
  const binaryInputValue = location.state.array64bitValueSwapped;
   const hexplaintext = location.state.hexplaintext;
  const hexkey = location.state.hexkey;
  const AllexcryptionResults = location.state.AllexcryptionResults;
  const binary64bitValueSwapped = location.state.binary64bitValueSwapped;
  const cipherhex = location.state.cipherhex;
  const inputValue = location.state.inputValue;
  const KeyValue = location.state.KeyValue;
  const bytes = location.state.bytes;
  const splitted_array = location.state.splitted_array
  const allResults = location.state.allResults

  const calculateBytes = (binaryInputValue, fpTable) => {
    if (binaryInputValue.length !== 8) {
      throw new Error("The binary input value array must contain 8 elements.");
    }
  
    if (binaryInputValue.join("").length !== 64) {
      throw new Error("The binary input value must contain 64 bits.");
    }
  
    const bytes = [];
    for (let i = 0; i < 8; i++) {
      const byteBits = [];
      for (let j = 0; j < 8; j++) {
        const bitIndex = fpTable[i * 8 + j] - 1; // Adjusted for 0-based indexing
        byteBits.push(binaryInputValue[Math.floor(bitIndex / 8)][bitIndex % 8]);
      }
      bytes.push(byteBits.join(""));
    }
  
    return bytes.join("");
  };

  const fpTable = [
    40, 8, 48, 16, 56, 24, 64, 32,
    39, 7, 47, 15, 55, 23, 63, 31,
    38, 6, 46, 14, 54, 22, 62, 30,
    37, 5, 45, 13, 53, 21, 61, 29,
    36, 4, 44, 12, 52, 20, 60, 28,
    35, 3, 43, 11, 51, 19, 59, 27,
    34, 2, 42, 10, 50, 18, 58, 26,
    33, 1, 41, 9, 49, 17, 57, 25,
  ];

  const ciphertext = calculateBytes(binaryInputValue, fpTable);
  console.log("cy",ciphertext);

  return (
    <>
    
    <div className="content-box">
      <h3 className="head">What is done in this page?</h3>
      <p>This page is about Final Permutation.The final permutation is the inverse of the initial permutation; the table is interpreted similarly
      </p>
    </div>
      <div className="input-container">
        <div className="flex flex-col items-center">
          

          <div className="flex flex-row">
            <div className="flex flex-col">
              <p>64 bit binary Value: </p>
              <div className="bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out tracking-widest-plus">
                {binaryInputValue[0]}
                <br></br>
                {binaryInputValue[1]}
                <br></br>
                {binaryInputValue[2]}
                <br></br>
                {binaryInputValue[3]}
                <br></br>
                {binaryInputValue[4]}
                <br></br>
                {binaryInputValue[5]}
                <br></br>
                {binaryInputValue[6]}
                <br></br>
                {binaryInputValue[7]}
                <br></br>
              </div>
              


            </div>
            <div className="px-5">
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              
              

              <svg width="87" height="54" viewBox="0 0 87 54" fill="none" xmlns="http://www.w3.org/2000/svg" className="mt-4">
<g filter="url(#filter0_d_347_2)">
<path d="M81.6739 33.5526C82.2597 34.1384 82.2597 35.0882 81.6739 35.6739L72.128 45.2199C71.5422 45.8057 70.5925 45.8057 70.0067 45.2199C69.4209 44.6341 69.4209 43.6843 70.0067 43.0986L78.492 34.6133L70.0067 26.128C69.4209 25.5422 69.4209 24.5925 70.0067 24.0067C70.5925 23.4209 71.5422 23.4209 72.128 24.0067L81.6739 33.5526ZM4.61328 33.1133L80.6133 33.1133V36.1133L4.61328 36.1133L4.61328 33.1133Z" fill="black"/>
</g>
<defs>
<filter id="filter0_d_347_2" x="0.613281" y="23.5674" width="85.5" height="30.0918" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="4"/>
<feGaussianBlur stdDeviation="2"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_347_2"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_347_2" result="shape"/>
</filter>
</defs>
</svg>


              <div class="button-holder">
                <div class="prev-button1" onClick={firstpage}>
                  PREVIOUS
                </div>
              </div>
            </div>
            <div className="flex flex-col">
              <p>Cipher Text</p>
              <div className="bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out tracking-widest-plus">
                {ciphertext.slice(0, 8)}
                <br></br>
                {ciphertext.slice(8, 16)}
                <br></br>
                {ciphertext.slice(16, 24)}
                <br></br>
                {ciphertext.slice(24, 32)}
                <br></br>
                {ciphertext.slice(32, 40)}
                <br></br>
                {ciphertext.slice(40, 48)}
                <br></br>
                {ciphertext.slice(48, 56)}
                <br></br>
                {ciphertext.slice(56, 64)}
                <br></br>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Final;
